import { Injectable } from '@angular/core';
import { RestService } from '@service/rest/rest.service';
import { SentryService } from '@service/sentry.service';
import { Entity } from '@model/entities/entity';
import { EntityTypeConfig } from '../model/entity-type-config';
import { EntityTypeConfigService } from './entity-type-config.service';

@Injectable({
  providedIn: 'root',
})
export class ViewCountService {
  constructor(
    private restService: RestService,
    private sentryService: SentryService,
    private entityTypeConfigService: EntityTypeConfigService,
  ) {}

  // this is a fire and forget request
  public addView(e: Entity): void {
    let entityTypeConfig: EntityTypeConfig = this.entityTypeConfigService.getConfigByEntity(e);

    let data = {
      model: entityTypeConfig.backendModelName,
      model_id: e.id,
    };

    this.restService.post('viewed/add', data, undefined, false).catch((err) => {
      this.sentryService.silentCaptureException(err);
    });
  }
}
